import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex justify-content-between mt-3 w-full" }
const _hoisted_3 = {
  key: 0,
  class: "flex my-1"
}
const _hoisted_4 = { class: "flex align-items-center" }
const _hoisted_5 = { class: "flex align-items-center ml-3" }
const _hoisted_6 = { class: "progress-indicator bg-white border-round-sm" }
const _hoisted_7 = { class: "ml-2 text-color-secondary" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "flex ml-auto"
}

import { computed, onMounted, ref, toRefs } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import Textarea from 'primevue/textarea';
import { AxiosResponse } from 'axios';
import ConfirmAction from '@/components/ConfirmAction';
import useUserTreatmentPlanStore from '@/store/People/Person/TreatmentPlans';
import { TreatmentGoalFormInterface } from '@/types/TreatmentPlans';
import { PersonStores } from '@/store';
import { can } from '@/composables';
import { EMIT, PERMISSIONS } from '@/enum';

interface Props {
  goal: TreatmentGoalFormInterface;
  serviceId: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Goal',
  props: {
    goal: {},
    serviceId: {}
  },
  emits: [EMIT.REMOVE, EMIT.ERROR, EMIT.SUCCESS, EMIT.NEW_GOAL, EMIT.UPDATE],
  setup(__props: any, { emit: __emit }) {

const treatmentPlanStore = useUserTreatmentPlanStore();
const treatmentPlansStore = PersonStores.useUserTreatmentPlansStore();
const toggleConfirmModal = ref(false);
const emit = __emit;
const props = __props;
const { goal, serviceId } = toRefs(props);
const editedGoal = ref<TreatmentGoalFormInterface>({ ...goal.value, treatment_goal_id: goal.value.id });
const complete = ref(!!goal.value.completed_at);
const currentDate = new Date();
const canEdit = computed(() => can([PERMISSIONS.TREATMENT_GOALS_UPDATE, PERMISSIONS.TREATMENT_SERVICES_GOALS_STORE]));
const savingGoal = ref(false);

const rules = computed(() => ({
  description: {
    required,
  },
  treatment_goal_type_id: {
    required,
  },
}));

const v$ = useVuelidate(rules, editedGoal);

onMounted(async () => {
  if (can([PERMISSIONS.TREATMENT_GOAL_TYPES_INDEX])) await treatmentPlansStore.getTreatmentPlanGoalsTypes();
});

const toggleSwitch = async () => {
  if (complete.value)
    editedGoal.value.completed_at =
      currentDate.toLocaleDateString('fr-CA') + ' ' + currentDate.toTimeString().split(' ')[0];
  else editedGoal.value.completed_at = '';

  treatmentPlanStore
    .editGoal({ treatment_goals: [editedGoal.value] }, serviceId.value as number)
    .then(onCompleteSuccess)
    .catch(onCompleteFailed);
};

const onCompleteSuccess = () => {
  if (complete.value) emit(EMIT.SUCCESS, 'Goal has been marked complete');
  else emit(EMIT.SUCCESS, 'Goal has been marked incomplete');
};

const onCompleteFailed = (error: AxiosResponse) => {
  emit(EMIT.ERROR, error.data.message);
};

const hasId = computed(() => !!goal.value.id);

const canComplete = computed<boolean>(() => hasId.value && canEdit.value);

const openConfirmModal = () => (toggleConfirmModal.value = true);

const removeGoal = () => {
  toggleConfirmModal.value = false;
  emit(EMIT.REMOVE, editedGoal.value);
};

const onCancel = () => {
  editedGoal.value = { ...goal.value, treatment_goal_id: goal.value.id };
  v$.value.$reset();
};

const onSave = async () => {
  savingGoal.value = true;
  if (editedGoal.value.id) {
    if (can([PERMISSIONS.TREATMENT_SERVICES_GOALS_UPDATE])) {
      await treatmentPlansStore.editGoal({ treatment_goals: [editedGoal.value] }, serviceId.value as number);
      emit(EMIT.UPDATE, 'Goal has been Updated');
    }
  } else {
    if (can([PERMISSIONS.TREATMENT_SERVICES_GOALS_UPDATE])) {
      await treatmentPlansStore
        .addGoal({ treatment_goals: [editedGoal.value] }, serviceId.value as number)
        .catch((err) => {
          return err;
        });
      emit(EMIT.NEW_GOAL, editedGoal.value);
      v$.value.$reset();
    }
  }
  savingGoal.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["p-2 mt-3 ml-3 surface-100 border-4 border-round-xl", _unref(v$).$dirty ? 'border-color-green-light' : 'border-100'])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Dropdown, {
          id: "treatment_goals_type_id",
          modelValue: _unref(v$).treatment_goal_type_id.$model,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).treatment_goal_type_id.$model) = $event)),
          options: _unref(treatmentPlansStore).treatmentPlanGoalsTypes,
          "option-label": "title",
          "option-value": "id",
          placeholder: "Goal Type",
          class: "mr-2",
          style: {"min-width":"150px"},
          disabled: !canEdit.value,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(v$)?.$touch()))
        }, null, 8, ["modelValue", "options", "disabled"]),
        _createVNode(_unref(Textarea), {
          id: "description",
          modelValue: _unref(v$).description.$model,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).description.$model) = $event)),
          type: "text",
          placeholder: "Description",
          class: _normalizeClass(["w-full", { 'p-invalid': _unref(v$)?.description.$errors.length }]),
          "auto-resize": true,
          rows: "1",
          cols: "30",
          disabled: !canEdit.value,
          onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_unref(v$)?.$touch()))
        }, null, 8, ["modelValue", "disabled", "class"]),
        (_unref(can)([_unref(PERMISSIONS).TREATMENT_SERVICES_GOALS_DELETE]))
          ? _withDirectives((_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "ml-3 my-1 m-icon delete text-color-secondary cursor-pointer",
              role: "button",
              onClick: _withModifiers(openConfirmModal, ["prevent"])
            }, null, 512)), [
              [
                _directive_tooltip,
                'Remove goal',
                void 0,
                { top: true }
              ]
            ])
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_2, [
        (canComplete.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "mr-2" }, "Mark Complete", -1)),
                _createVNode(_component_InputSwitch, {
                  modelValue: complete.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((complete).value = $event)),
                  onChange: toggleSwitch
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", {
                    class: "progress-indicator-percentage",
                    style: _normalizeStyle({ width: editedGoal.value.measurements_average_percentage + '%' })
                  }, null, 4)
                ]),
                _createElementVNode("p", _hoisted_7, [
                  _createElementVNode("b", null, _toDisplayString(editedGoal.value.measurements_average_percentage) + "%", 1),
                  _cache[7] || (_cache[7] = _createTextVNode(" Achieved ", -1)),
                  (editedGoal.value.measurements_count > 0)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_8, "out of " + _toDisplayString(editedGoal.value.measurements_count) + " attempts", 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(v$)?.$dirty)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_AppButton, {
                type: "secondary",
                text: "Cancel",
                class: "ml-3",
                onClick: onCancel
              }),
              (_unref(can)([_unref(PERMISSIONS).TREATMENT_SERVICES_GOALS_UPDATE, _unref(PERMISSIONS).TREATMENT_SERVICES_GOALS_STORE]))
                ? (_openBlock(), _createBlock(_component_AppButton, {
                    key: 0,
                    type: "primary",
                    text: "Save Goal",
                    class: "ml-3",
                    loading: savingGoal.value,
                    disabled: _unref(v$)?.$errors.length > 0,
                    onClick: onSave
                  }, null, 8, ["loading", "disabled"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (toggleConfirmModal.value && _unref(can)([_unref(PERMISSIONS).TREATMENT_SERVICES_GOALS_DELETE]))
      ? (_openBlock(), _createBlock(_unref(ConfirmAction), {
          key: 0,
          header: "Delete goal",
          "accept-label": "Delete",
          onAccept: removeGoal,
          onCancel: _cache[5] || (_cache[5] = ($event: any) => (toggleConfirmModal.value = false))
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createElementVNode("span", null, "Are you sure that you want to remove this goal ?", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})